import {formatLocaleDate} from '@/dayjs'
import {StyledAgendaHeaderDay, StyledAgendaHeaderDayNumber} from '@/features/agenda/components/agenda-header-day/style'
import {useMemo} from 'react'

export const AgendaHeaderDay = ({
    date,
    formatDay,
    formatDayNumber
}: {
    date: Date
    formatDay?: string | null
    formatDayNumber?: string | null
}) => {
    const day = useMemo(() => formatDay && formatLocaleDate(date, formatDay), [date, formatDay])
    const dayNumber = useMemo(() => formatDayNumber && formatLocaleDate(date, formatDayNumber), [date, formatDayNumber])

    return (
        <StyledAgendaHeaderDay>
            {day && <span>{day}</span>}{' '}
            {dayNumber && <StyledAgendaHeaderDayNumber className="day-number">{dayNumber}</StyledAgendaHeaderDayNumber>}
        </StyledAgendaHeaderDay>
    )
}
